export const environment = {
  production: false,
  local: false,
  oauth: {
    issuer: 'https://login.microsoftonline.com/b914a242-e718-443b-a47c-6b4c649d8c0a/v2.0',
    clientId: '9fd9a192-1ccc-4634-9cb7-44c0a0b30f80',
    useLocalConfig: false,
  },
  apiUrls: {
    gandalf: 'https://ca-starshipzero-dev.salmonsea-32435f6b.westeurope.azurecontainerapps.io',// Dev Gandalf Backend
    vision0: 'https://ca-hse0-dev.salmonsea-32435f6b.westeurope.azurecontainerapps.io', // Dev Visio 0 Backend
  }, // Dev Backend URL
  apiScope: 'openid profile email api://83f7bbba-c74e-4332-8c8d-9caba5bd8971/gandalf',
};
